import { Injectable, inject } from '@angular/core';

import { Store, select } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, withLatestFrom } from 'rxjs/operators';

import {
    CustomViewsActions,
    getSelectedId,
} from '@qwyk/shared-stores/custom-views';

import { ShipmentsActions } from './shipments.actions';
import { getShipmentColumns } from '../shipmentsConstants';

export const DEFAULT_VIEW_ID = 'default';

@Injectable()
export class ShipmentsCustomViewsEffects {
    private readonly actions$ = inject(Actions);
    private readonly store = inject(Store);

    private readonly DEFAULT_SHIPMENT_VIEW = {
        uid: DEFAULT_VIEW_ID,
        name: 'Default View',
        columns: getShipmentColumns()
            .filter(c => c.default)
            .map(c => (c.sub_key ? `${c.key}.${c.sub_key}` : c.key)),
        default_view: false,
        is_current: false,
    };

    initializeFromShipments$ = createEffect(() =>
        this.actions$.pipe(
            ofType(ShipmentsActions.loadShipmentsSuccess, ShipmentsActions.loadDraftShipmentsSuccess),
            withLatestFrom(this.store.pipe(select(getSelectedId))),
            map(([action, selectedViewId]) => {
                const isCurrentView = action.customViews.some(cv => cv.is_current);
                const selectedId = selectedViewId ?? (isCurrentView ? action.customViews.find(cv => cv.is_current).uid : this.DEFAULT_SHIPMENT_VIEW.uid);

                return CustomViewsActions.loadCustomViewsSuccess({
                    parent: 'shipment',
                    custom_views: [this.DEFAULT_SHIPMENT_VIEW, ...action.customViews],
                    selectedId,
                });
            })
        )
    );
}
